/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { UserManagementForgotPasswordResponse } from "./UserManagementForgotPasswordResponse";

export type UserManagementForgotPasswordResponseApiRespoonse = {
  data?: UserManagementForgotPasswordResponse;
  status?: UserManagementForgotPasswordResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace UserManagementForgotPasswordResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
